import { render, staticRenderFns } from "./KanbanExample.vue?vue&type=template&id=43d626e0&scoped=true"
import script from "./KanbanExample.vue?vue&type=script&lang=js"
export * from "./KanbanExample.vue?vue&type=script&lang=js"
import style0 from "./KanbanExample.vue?vue&type=style&index=0&id=43d626e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43d626e0",
  null
  
)

export default component.exports